import { useNotificationPreference } from '@seek/hirer-notification-preference';
import { useTranslations } from '@vocab/react';
import { Badge, Inline, Stack, Strong, Text } from 'braid-design-system';
import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import type { AppState } from 'src/types/appState';

import translations from './.vocab';

export const CurrentNotificationPreference = () => {
  const { userEmailAddress, notificationPreference } = useSelector(
    (state: AppState) => ({
      notificationPreference:
        state.session.notificationsSetting.savedNotificationPreference,
      userEmailAddress: state.session.userEmailAddress,
    }),
    shallowEqual,
  );
  const notificationOptionSetting = useNotificationPreference({
    preference: notificationPreference,
  });
  const { t } = useTranslations(translations);
  return notificationOptionSetting ? (
    <Stack space={['medium', 'small']}>
      <Inline space={['small', 'xxsmall']} alignY="center">
        <Text>{t('current-notification-preference-frequency-text')}</Text>
        <Text weight="strong">
          {notificationOptionSetting.frequencyText}{' '}
          {notificationOptionSetting.promote && (
            <Badge tone="promote">{t('recommended-badge-text')}</Badge>
          )}
        </Text>
      </Inline>

      {notificationPreference &&
        notificationPreference.frequency !== 'NEVER' && (
          <Text>
            {t('email-sent-to-text', {
              receiverEmail:
                notificationPreference.frequency === 'EVERY_APPLICATION' &&
                notificationPreference.everyApplicationEmail
                  ? notificationPreference.everyApplicationEmail
                  : userEmailAddress,
              Strong: (children) => <Strong>{children}</Strong>,
            })}
          </Text>
        )}
    </Stack>
  ) : (
    <></>
  );
};
